const readFile = (data, filename, contentType, action) => {
  let blob = typeof File === 'function'
      ? new File([data], filename, { type: contentType })
      : new Blob([data], { type: contentType });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
  } else {
      let URL = window.URL || window.webkitURL;
      let downloadUrl = URL.createObjectURL(blob);
      let video = document.querySelector('video');
      if (action === 'video') {
          video.src = URL.createObjectURL(blob);
          video.setAttribute("controlsList", "nodownload");
      }
      else {
          if (filename) {
              // use HTML5 a[download] attribute to specify filename
              var a = document.createElement("a");
              // safari doesn't support this yet
              if (typeof a.download === 'undefined') {
                  window.location = downloadUrl;
              } else {
                  a.href = downloadUrl;
                  a.download = filename;
                  document.body.appendChild(a);
                  a.click();
              }
          } else {
              window.location = downloadUrl;
          }
      }
      setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
  }
};

export default  readFile;


// WEBPACK FOOTER //
// ./src/utils/readFile.js